const isDevelopment = process.env.NODE_ENV === 'development';
export const API_BASE_URL = isDevelopment 
  ? 'http://localhost:5000/api/' 
  : 'http://acc1.somee.com/api/';
  // : 'https://accountant1.bsite.net/api/';


